/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ArchiveCompletionSummaryResponseDto,
  ArchiveContainerRequestDto,
  ArchiveOptionRequestDto,
  ArchiveOptionResponseDto,
  ContainerArchivePrecheckResponseDto,
  ContainerDetailDto,
  ContainerListItemDto,
  ContainersControllerGetContainerParams,
  ContainersControllerGetPartnerContainersParams,
  ContainersControllerListContainersParams,
  CreateContainerDto,
  CreateContainerOptionDto,
  OptionArchivePrecheckResponseDto,
  PartnerContainerConfigDto,
  PartnerContainerOptionOverrideDto,
  PartnerContainerResponseDto,
  ToggleContainerProductTypeDto,
  ToggleOptionProductTypeDto,
  UpdateContainerDto,
  UpdateContainerOptionDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns containers in the Container Library, ordered by sort_order, with a count of options per container. Admins may call without partner_id for the full library. With partner_id (required for non-admin callers, who must be members of that partner), the list is scoped to standard containers plus that partner’s own customs, and option counts exclude other partners’ custom options.
 * @summary List all containers with option counts
 */
export type containersControllerListContainersResponse200 = {
  data: ContainerListItemDto[]
  status: 200
}

export type containersControllerListContainersResponse400 = {
  data: void
  status: 400
}

export type containersControllerListContainersResponse401 = {
  data: void
  status: 401
}

export type containersControllerListContainersResponse403 = {
  data: void
  status: 403
}
    
export type containersControllerListContainersResponseSuccess = (containersControllerListContainersResponse200) & {
  headers: Headers;
};
export type containersControllerListContainersResponseError = (containersControllerListContainersResponse400 | containersControllerListContainersResponse401 | containersControllerListContainersResponse403) & {
  headers: Headers;
};

export type containersControllerListContainersResponse = (containersControllerListContainersResponseSuccess | containersControllerListContainersResponseError)

export const getContainersControllerListContainersUrl = (params?: ContainersControllerListContainersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/containers?${stringifiedParams}` : `/containers`
}

export const containersControllerListContainers = async (params?: ContainersControllerListContainersParams, options?: RequestInit): Promise<containersControllerListContainersResponse> => {
  
  return customFetch<containersControllerListContainersResponse>(getContainersControllerListContainersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContainersControllerListContainersQueryKey = (params?: ContainersControllerListContainersParams,) => {
    return [
    `/containers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContainersControllerListContainersQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerListContainersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerListContainers>>> = ({ signal }) => containersControllerListContainers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerListContainersQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerListContainers>>>
export type ContainersControllerListContainersQueryError = void


export function useContainersControllerListContainers<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params: undefined |  ContainersControllerListContainersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerListContainers>>,
          TError,
          Awaited<ReturnType<typeof containersControllerListContainers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerListContainers<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerListContainers>>,
          TError,
          Awaited<ReturnType<typeof containersControllerListContainers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerListContainers<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all containers with option counts
 */

export function useContainersControllerListContainers<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerListContainersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List all containers with option counts
 */
export const prefetchContainersControllerListContainersQuery = async <TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 queryClient: QueryClient, params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getContainersControllerListContainersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getContainersControllerListContainersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerListContainersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerListContainers>>> = ({ signal }) => containersControllerListContainers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerListContainersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerListContainers>>>
export type ContainersControllerListContainersSuspenseQueryError = void


export function useContainersControllerListContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params: undefined |  ContainersControllerListContainersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerListContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerListContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all containers with option counts
 */

export function useContainersControllerListContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerListContainers>>, TError = void>(
 params?: ContainersControllerListContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerListContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerListContainersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new container in the Container Library. Admin-only.
 * @summary Create a new container
 */
export type containersControllerCreateContainerResponse201 = {
  data: ContainerDetailDto
  status: 201
}

export type containersControllerCreateContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerCreateContainerResponse403 = {
  data: void
  status: 403
}
    
export type containersControllerCreateContainerResponseSuccess = (containersControllerCreateContainerResponse201) & {
  headers: Headers;
};
export type containersControllerCreateContainerResponseError = (containersControllerCreateContainerResponse401 | containersControllerCreateContainerResponse403) & {
  headers: Headers;
};

export type containersControllerCreateContainerResponse = (containersControllerCreateContainerResponseSuccess | containersControllerCreateContainerResponseError)

export const getContainersControllerCreateContainerUrl = () => {


  

  return `/containers`
}

export const containersControllerCreateContainer = async (createContainerDto: CreateContainerDto, options?: RequestInit): Promise<containersControllerCreateContainerResponse> => {
  
  return customFetch<containersControllerCreateContainerResponse>(getContainersControllerCreateContainerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContainerDto,)
  }
);}




export const getContainersControllerCreateContainerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreateContainer>>, TError,{data: CreateContainerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreateContainer>>, TError,{data: CreateContainerDto}, TContext> => {

const mutationKey = ['containersControllerCreateContainer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerCreateContainer>>, {data: CreateContainerDto}> = (props) => {
          const {data} = props ?? {};

          return  containersControllerCreateContainer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerCreateContainerMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerCreateContainer>>>
    export type ContainersControllerCreateContainerMutationBody = CreateContainerDto
    export type ContainersControllerCreateContainerMutationError = void

    /**
 * @summary Create a new container
 */
export const useContainersControllerCreateContainer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreateContainer>>, TError,{data: CreateContainerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerCreateContainer>>,
        TError,
        {data: CreateContainerDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerCreateContainerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns containers activated for a partner the caller belongs to, with display_order and score/weight overrides applied. Active rows only by default; pass include_inactive=true to receive deactivated rows too (used by the partner container config page).
 * @summary Get a partner's containers with options
 */
export type containersControllerGetPartnerContainersResponse200 = {
  data: PartnerContainerResponseDto[]
  status: 200
}

export type containersControllerGetPartnerContainersResponse401 = {
  data: void
  status: 401
}

export type containersControllerGetPartnerContainersResponse403 = {
  data: void
  status: 403
}
    
export type containersControllerGetPartnerContainersResponseSuccess = (containersControllerGetPartnerContainersResponse200) & {
  headers: Headers;
};
export type containersControllerGetPartnerContainersResponseError = (containersControllerGetPartnerContainersResponse401 | containersControllerGetPartnerContainersResponse403) & {
  headers: Headers;
};

export type containersControllerGetPartnerContainersResponse = (containersControllerGetPartnerContainersResponseSuccess | containersControllerGetPartnerContainersResponseError)

export const getContainersControllerGetPartnerContainersUrl = (params: ContainersControllerGetPartnerContainersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/containers/partner?${stringifiedParams}` : `/containers/partner`
}

export const containersControllerGetPartnerContainers = async (params: ContainersControllerGetPartnerContainersParams, options?: RequestInit): Promise<containersControllerGetPartnerContainersResponse> => {
  
  return customFetch<containersControllerGetPartnerContainersResponse>(getContainersControllerGetPartnerContainersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContainersControllerGetPartnerContainersQueryKey = (params?: ContainersControllerGetPartnerContainersParams,) => {
    return [
    `/containers/partner`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContainersControllerGetPartnerContainersQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerGetPartnerContainersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>> = ({ signal }) => containersControllerGetPartnerContainers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerGetPartnerContainersQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>>
export type ContainersControllerGetPartnerContainersQueryError = void


export function useContainersControllerGetPartnerContainers<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>,
          TError,
          Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetPartnerContainers<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>,
          TError,
          Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetPartnerContainers<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a partner's containers with options
 */

export function useContainersControllerGetPartnerContainers<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerGetPartnerContainersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a partner's containers with options
 */
export const prefetchContainersControllerGetPartnerContainersQuery = async <TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 queryClient: QueryClient, params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getContainersControllerGetPartnerContainersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getContainersControllerGetPartnerContainersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerGetPartnerContainersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>> = ({ signal }) => containersControllerGetPartnerContainers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerGetPartnerContainersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>>
export type ContainersControllerGetPartnerContainersSuspenseQueryError = void


export function useContainersControllerGetPartnerContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetPartnerContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetPartnerContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a partner's containers with options
 */

export function useContainersControllerGetPartnerContainersSuspense<TData = Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError = void>(
 params: ContainersControllerGetPartnerContainersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetPartnerContainers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerGetPartnerContainersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Upserts a partner-container relationship: sets is_active, display_order and use_for_label. The caller must belong to the target partner (or be an Artic admin) — partners self-manage which containers are active and labelled (ENG-628).
 * @summary Activate or configure a container for a partner
 */
export type containersControllerActivatePartnerContainerResponse201 = {
  data: PartnerContainerConfigDto
  status: 201
}

export type containersControllerActivatePartnerContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerActivatePartnerContainerResponse403 = {
  data: void
  status: 403
}
    
export type containersControllerActivatePartnerContainerResponseSuccess = (containersControllerActivatePartnerContainerResponse201) & {
  headers: Headers;
};
export type containersControllerActivatePartnerContainerResponseError = (containersControllerActivatePartnerContainerResponse401 | containersControllerActivatePartnerContainerResponse403) & {
  headers: Headers;
};

export type containersControllerActivatePartnerContainerResponse = (containersControllerActivatePartnerContainerResponseSuccess | containersControllerActivatePartnerContainerResponseError)

export const getContainersControllerActivatePartnerContainerUrl = () => {


  

  return `/containers/partner`
}

export const containersControllerActivatePartnerContainer = async (partnerContainerConfigDto: PartnerContainerConfigDto, options?: RequestInit): Promise<containersControllerActivatePartnerContainerResponse> => {
  
  return customFetch<containersControllerActivatePartnerContainerResponse>(getContainersControllerActivatePartnerContainerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partnerContainerConfigDto,)
  }
);}




export const getContainersControllerActivatePartnerContainerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerActivatePartnerContainer>>, TError,{data: PartnerContainerConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerActivatePartnerContainer>>, TError,{data: PartnerContainerConfigDto}, TContext> => {

const mutationKey = ['containersControllerActivatePartnerContainer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerActivatePartnerContainer>>, {data: PartnerContainerConfigDto}> = (props) => {
          const {data} = props ?? {};

          return  containersControllerActivatePartnerContainer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerActivatePartnerContainerMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerActivatePartnerContainer>>>
    export type ContainersControllerActivatePartnerContainerMutationBody = PartnerContainerConfigDto
    export type ContainersControllerActivatePartnerContainerMutationError = void

    /**
 * @summary Activate or configure a container for a partner
 */
export const useContainersControllerActivatePartnerContainer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerActivatePartnerContainer>>, TError,{data: PartnerContainerConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerActivatePartnerContainer>>,
        TError,
        {data: PartnerContainerConfigDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerActivatePartnerContainerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Creates a custom container owned by a partner the caller has access to. Requires is_standard=false and a non-null owner_partner_id; the caller must belong to that partner (or be an Artic admin). The new container is auto-activated in the partner containers junction so it appears immediately in the partner's container config.
 * @summary Create a partner-owned (custom) container
 */
export type containersControllerCreatePartnerOwnedContainerResponse201 = {
  data: ContainerDetailDto
  status: 201
}

export type containersControllerCreatePartnerOwnedContainerResponse400 = {
  data: void
  status: 400
}

export type containersControllerCreatePartnerOwnedContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerCreatePartnerOwnedContainerResponse403 = {
  data: void
  status: 403
}
    
export type containersControllerCreatePartnerOwnedContainerResponseSuccess = (containersControllerCreatePartnerOwnedContainerResponse201) & {
  headers: Headers;
};
export type containersControllerCreatePartnerOwnedContainerResponseError = (containersControllerCreatePartnerOwnedContainerResponse400 | containersControllerCreatePartnerOwnedContainerResponse401 | containersControllerCreatePartnerOwnedContainerResponse403) & {
  headers: Headers;
};

export type containersControllerCreatePartnerOwnedContainerResponse = (containersControllerCreatePartnerOwnedContainerResponseSuccess | containersControllerCreatePartnerOwnedContainerResponseError)

export const getContainersControllerCreatePartnerOwnedContainerUrl = () => {


  

  return `/containers/partner-owned`
}

export const containersControllerCreatePartnerOwnedContainer = async (createContainerDto: CreateContainerDto, options?: RequestInit): Promise<containersControllerCreatePartnerOwnedContainerResponse> => {
  
  return customFetch<containersControllerCreatePartnerOwnedContainerResponse>(getContainersControllerCreatePartnerOwnedContainerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContainerDto,)
  }
);}




export const getContainersControllerCreatePartnerOwnedContainerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainer>>, TError,{data: CreateContainerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainer>>, TError,{data: CreateContainerDto}, TContext> => {

const mutationKey = ['containersControllerCreatePartnerOwnedContainer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainer>>, {data: CreateContainerDto}> = (props) => {
          const {data} = props ?? {};

          return  containersControllerCreatePartnerOwnedContainer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerCreatePartnerOwnedContainerMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainer>>>
    export type ContainersControllerCreatePartnerOwnedContainerMutationBody = CreateContainerDto
    export type ContainersControllerCreatePartnerOwnedContainerMutationError = void

    /**
 * @summary Create a partner-owned (custom) container
 */
export const useContainersControllerCreatePartnerOwnedContainer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainer>>, TError,{data: CreateContainerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainer>>,
        TError,
        {data: CreateContainerDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerCreatePartnerOwnedContainerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns a single container with its full list of options, ordered by option_sort_order. Admins may call without partner_id for the unscoped library detail. With partner_id (required for non-admin callers, who must be members of that partner), options are filtered to global plus that partner’s own customs, and another partner’s custom container reads as 404.
 * @summary Get container with all options
 */
export type containersControllerGetContainerResponse200 = {
  data: ContainerDetailDto
  status: 200
}

export type containersControllerGetContainerResponse400 = {
  data: void
  status: 400
}

export type containersControllerGetContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerGetContainerResponse403 = {
  data: void
  status: 403
}

export type containersControllerGetContainerResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerGetContainerResponseSuccess = (containersControllerGetContainerResponse200) & {
  headers: Headers;
};
export type containersControllerGetContainerResponseError = (containersControllerGetContainerResponse400 | containersControllerGetContainerResponse401 | containersControllerGetContainerResponse403 | containersControllerGetContainerResponse404) & {
  headers: Headers;
};

export type containersControllerGetContainerResponse = (containersControllerGetContainerResponseSuccess | containersControllerGetContainerResponseError)

export const getContainersControllerGetContainerUrl = (containerId: string,
    params?: ContainersControllerGetContainerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/containers/${containerId}?${stringifiedParams}` : `/containers/${containerId}`
}

export const containersControllerGetContainer = async (containerId: string,
    params?: ContainersControllerGetContainerParams, options?: RequestInit): Promise<containersControllerGetContainerResponse> => {
  
  return customFetch<containersControllerGetContainerResponse>(getContainersControllerGetContainerUrl(containerId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContainersControllerGetContainerQueryKey = (containerId?: string,
    params?: ContainersControllerGetContainerParams,) => {
    return [
    `/containers/${containerId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContainersControllerGetContainerQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerGetContainerQueryKey(containerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerGetContainer>>> = ({ signal }) => containersControllerGetContainer(containerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(containerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerGetContainerQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerGetContainer>>>
export type ContainersControllerGetContainerQueryError = void


export function useContainersControllerGetContainer<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params: undefined |  ContainersControllerGetContainerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerGetContainer>>,
          TError,
          Awaited<ReturnType<typeof containersControllerGetContainer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetContainer<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerGetContainer>>,
          TError,
          Awaited<ReturnType<typeof containersControllerGetContainer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetContainer<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get container with all options
 */

export function useContainersControllerGetContainer<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerGetContainerQueryOptions(containerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get container with all options
 */
export const prefetchContainersControllerGetContainerQuery = async <TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 queryClient: QueryClient, containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getContainersControllerGetContainerQueryOptions(containerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getContainersControllerGetContainerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerGetContainerQueryKey(containerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerGetContainer>>> = ({ signal }) => containersControllerGetContainer(containerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerGetContainerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerGetContainer>>>
export type ContainersControllerGetContainerSuspenseQueryError = void


export function useContainersControllerGetContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params: undefined |  ContainersControllerGetContainerParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerGetContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get container with all options
 */

export function useContainersControllerGetContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerGetContainer>>, TError = void>(
 containerId: string,
    params?: ContainersControllerGetContainerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerGetContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerGetContainerSuspenseQueryOptions(containerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates container metadata. Admins may update any container; partner members may update their own custom containers but not container_key, container_sort_order, or is_standard (those fields are admin-only).
 * @summary Update a container
 */
export type containersControllerUpdateContainerResponse200 = {
  data: ContainerDetailDto
  status: 200
}

export type containersControllerUpdateContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerUpdateContainerResponse403 = {
  data: void
  status: 403
}

export type containersControllerUpdateContainerResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerUpdateContainerResponseSuccess = (containersControllerUpdateContainerResponse200) & {
  headers: Headers;
};
export type containersControllerUpdateContainerResponseError = (containersControllerUpdateContainerResponse401 | containersControllerUpdateContainerResponse403 | containersControllerUpdateContainerResponse404) & {
  headers: Headers;
};

export type containersControllerUpdateContainerResponse = (containersControllerUpdateContainerResponseSuccess | containersControllerUpdateContainerResponseError)

export const getContainersControllerUpdateContainerUrl = (containerId: string,) => {


  

  return `/containers/${containerId}`
}

export const containersControllerUpdateContainer = async (containerId: string,
    updateContainerDto: UpdateContainerDto, options?: RequestInit): Promise<containersControllerUpdateContainerResponse> => {
  
  return customFetch<containersControllerUpdateContainerResponse>(getContainersControllerUpdateContainerUrl(containerId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContainerDto,)
  }
);}




export const getContainersControllerUpdateContainerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerUpdateContainer>>, TError,{containerId: string;data: UpdateContainerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerUpdateContainer>>, TError,{containerId: string;data: UpdateContainerDto}, TContext> => {

const mutationKey = ['containersControllerUpdateContainer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerUpdateContainer>>, {containerId: string;data: UpdateContainerDto}> = (props) => {
          const {containerId,data} = props ?? {};

          return  containersControllerUpdateContainer(containerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerUpdateContainerMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerUpdateContainer>>>
    export type ContainersControllerUpdateContainerMutationBody = UpdateContainerDto
    export type ContainersControllerUpdateContainerMutationError = void

    /**
 * @summary Update a container
 */
export const useContainersControllerUpdateContainer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerUpdateContainer>>, TError,{containerId: string;data: UpdateContainerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerUpdateContainer>>,
        TError,
        {containerId: string;data: UpdateContainerDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerUpdateContainerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Hard-deletes a container that has zero options — a safe operation, since no Planner data, work-order usage, or product selections can exist without options. Rejected (400) if the container still has any options (archive it instead). Custom containers require membership of the owning partner; standard/global containers require an Artic admin.
 * @summary Permanently delete a container with no options
 */
export type containersControllerDeleteContainerResponse200 = {
  data: void
  status: 200
}

export type containersControllerDeleteContainerResponse400 = {
  data: void
  status: 400
}

export type containersControllerDeleteContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerDeleteContainerResponse403 = {
  data: void
  status: 403
}

export type containersControllerDeleteContainerResponse404 = {
  data: void
  status: 404
}

export type containersControllerDeleteContainerResponse409 = {
  data: void
  status: 409
}
    
export type containersControllerDeleteContainerResponseSuccess = (containersControllerDeleteContainerResponse200) & {
  headers: Headers;
};
export type containersControllerDeleteContainerResponseError = (containersControllerDeleteContainerResponse400 | containersControllerDeleteContainerResponse401 | containersControllerDeleteContainerResponse403 | containersControllerDeleteContainerResponse404 | containersControllerDeleteContainerResponse409) & {
  headers: Headers;
};

export type containersControllerDeleteContainerResponse = (containersControllerDeleteContainerResponseSuccess | containersControllerDeleteContainerResponseError)

export const getContainersControllerDeleteContainerUrl = (containerId: string,) => {


  

  return `/containers/${containerId}`
}

export const containersControllerDeleteContainer = async (containerId: string, options?: RequestInit): Promise<containersControllerDeleteContainerResponse> => {
  
  return customFetch<containersControllerDeleteContainerResponse>(getContainersControllerDeleteContainerUrl(containerId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getContainersControllerDeleteContainerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerDeleteContainer>>, TError,{containerId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerDeleteContainer>>, TError,{containerId: string}, TContext> => {

const mutationKey = ['containersControllerDeleteContainer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerDeleteContainer>>, {containerId: string}> = (props) => {
          const {containerId} = props ?? {};

          return  containersControllerDeleteContainer(containerId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerDeleteContainerMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerDeleteContainer>>>
    
    export type ContainersControllerDeleteContainerMutationError = void

    /**
 * @summary Permanently delete a container with no options
 */
export const useContainersControllerDeleteContainer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerDeleteContainer>>, TError,{containerId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerDeleteContainer>>,
        TError,
        {containerId: string},
        TContext
      > => {

      const mutationOptions = getContainersControllerDeleteContainerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Creates a new option within a container. Option code must be unique across all containers. Admin-only.
 * @summary Add an option to a container
 */
export type containersControllerCreateContainerOptionResponse201 = {
  data: ContainerDetailDto
  status: 201
}

export type containersControllerCreateContainerOptionResponse401 = {
  data: void
  status: 401
}

export type containersControllerCreateContainerOptionResponse403 = {
  data: void
  status: 403
}

export type containersControllerCreateContainerOptionResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerCreateContainerOptionResponseSuccess = (containersControllerCreateContainerOptionResponse201) & {
  headers: Headers;
};
export type containersControllerCreateContainerOptionResponseError = (containersControllerCreateContainerOptionResponse401 | containersControllerCreateContainerOptionResponse403 | containersControllerCreateContainerOptionResponse404) & {
  headers: Headers;
};

export type containersControllerCreateContainerOptionResponse = (containersControllerCreateContainerOptionResponseSuccess | containersControllerCreateContainerOptionResponseError)

export const getContainersControllerCreateContainerOptionUrl = (containerId: string,) => {


  

  return `/containers/${containerId}/options`
}

export const containersControllerCreateContainerOption = async (containerId: string,
    createContainerOptionDto: CreateContainerOptionDto, options?: RequestInit): Promise<containersControllerCreateContainerOptionResponse> => {
  
  return customFetch<containersControllerCreateContainerOptionResponse>(getContainersControllerCreateContainerOptionUrl(containerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContainerOptionDto,)
  }
);}




export const getContainersControllerCreateContainerOptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreateContainerOption>>, TError,{containerId: string;data: CreateContainerOptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreateContainerOption>>, TError,{containerId: string;data: CreateContainerOptionDto}, TContext> => {

const mutationKey = ['containersControllerCreateContainerOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerCreateContainerOption>>, {containerId: string;data: CreateContainerOptionDto}> = (props) => {
          const {containerId,data} = props ?? {};

          return  containersControllerCreateContainerOption(containerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerCreateContainerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerCreateContainerOption>>>
    export type ContainersControllerCreateContainerOptionMutationBody = CreateContainerOptionDto
    export type ContainersControllerCreateContainerOptionMutationError = void

    /**
 * @summary Add an option to a container
 */
export const useContainersControllerCreateContainerOption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreateContainerOption>>, TError,{containerId: string;data: CreateContainerOptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerCreateContainerOption>>,
        TError,
        {containerId: string;data: CreateContainerOptionDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerCreateContainerOptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Creates a partner-specific option within a container. Requires is_standard=false and a non-null owner_partner_id; the caller must belong to that partner (or be an Artic admin). The container itself must be standard (owner null) or owned by the same partner. Mirrors POST /containers/partner-owned for the option layer.
 * @summary Add a partner-owned option to a container
 */
export type containersControllerCreatePartnerOwnedContainerOptionResponse201 = {
  data: ContainerDetailDto
  status: 201
}

export type containersControllerCreatePartnerOwnedContainerOptionResponse400 = {
  data: void
  status: 400
}

export type containersControllerCreatePartnerOwnedContainerOptionResponse401 = {
  data: void
  status: 401
}

export type containersControllerCreatePartnerOwnedContainerOptionResponse403 = {
  data: void
  status: 403
}

export type containersControllerCreatePartnerOwnedContainerOptionResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerCreatePartnerOwnedContainerOptionResponseSuccess = (containersControllerCreatePartnerOwnedContainerOptionResponse201) & {
  headers: Headers;
};
export type containersControllerCreatePartnerOwnedContainerOptionResponseError = (containersControllerCreatePartnerOwnedContainerOptionResponse400 | containersControllerCreatePartnerOwnedContainerOptionResponse401 | containersControllerCreatePartnerOwnedContainerOptionResponse403 | containersControllerCreatePartnerOwnedContainerOptionResponse404) & {
  headers: Headers;
};

export type containersControllerCreatePartnerOwnedContainerOptionResponse = (containersControllerCreatePartnerOwnedContainerOptionResponseSuccess | containersControllerCreatePartnerOwnedContainerOptionResponseError)

export const getContainersControllerCreatePartnerOwnedContainerOptionUrl = (containerId: string,) => {


  

  return `/containers/${containerId}/partner-owned-options`
}

export const containersControllerCreatePartnerOwnedContainerOption = async (containerId: string,
    createContainerOptionDto: CreateContainerOptionDto, options?: RequestInit): Promise<containersControllerCreatePartnerOwnedContainerOptionResponse> => {
  
  return customFetch<containersControllerCreatePartnerOwnedContainerOptionResponse>(getContainersControllerCreatePartnerOwnedContainerOptionUrl(containerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContainerOptionDto,)
  }
);}




export const getContainersControllerCreatePartnerOwnedContainerOptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainerOption>>, TError,{containerId: string;data: CreateContainerOptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainerOption>>, TError,{containerId: string;data: CreateContainerOptionDto}, TContext> => {

const mutationKey = ['containersControllerCreatePartnerOwnedContainerOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainerOption>>, {containerId: string;data: CreateContainerOptionDto}> = (props) => {
          const {containerId,data} = props ?? {};

          return  containersControllerCreatePartnerOwnedContainerOption(containerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerCreatePartnerOwnedContainerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainerOption>>>
    export type ContainersControllerCreatePartnerOwnedContainerOptionMutationBody = CreateContainerOptionDto
    export type ContainersControllerCreatePartnerOwnedContainerOptionMutationError = void

    /**
 * @summary Add a partner-owned option to a container
 */
export const useContainersControllerCreatePartnerOwnedContainerOption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainerOption>>, TError,{containerId: string;data: CreateContainerOptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerCreatePartnerOwnedContainerOption>>,
        TError,
        {containerId: string;data: CreateContainerOptionDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerCreatePartnerOwnedContainerOptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Updates option properties. Admins may update any option; partner members may update their own custom options but not option_code, option_weight, or is_standard (those fields are admin-only).
 * @summary Update a container option
 */
export type containersControllerUpdateContainerOptionResponse200 = {
  data: ContainerDetailDto
  status: 200
}

export type containersControllerUpdateContainerOptionResponse401 = {
  data: void
  status: 401
}

export type containersControllerUpdateContainerOptionResponse403 = {
  data: void
  status: 403
}

export type containersControllerUpdateContainerOptionResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerUpdateContainerOptionResponseSuccess = (containersControllerUpdateContainerOptionResponse200) & {
  headers: Headers;
};
export type containersControllerUpdateContainerOptionResponseError = (containersControllerUpdateContainerOptionResponse401 | containersControllerUpdateContainerOptionResponse403 | containersControllerUpdateContainerOptionResponse404) & {
  headers: Headers;
};

export type containersControllerUpdateContainerOptionResponse = (containersControllerUpdateContainerOptionResponseSuccess | containersControllerUpdateContainerOptionResponseError)

export const getContainersControllerUpdateContainerOptionUrl = (optionId: string,) => {


  

  return `/containers/options/${optionId}`
}

export const containersControllerUpdateContainerOption = async (optionId: string,
    updateContainerOptionDto: UpdateContainerOptionDto, options?: RequestInit): Promise<containersControllerUpdateContainerOptionResponse> => {
  
  return customFetch<containersControllerUpdateContainerOptionResponse>(getContainersControllerUpdateContainerOptionUrl(optionId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContainerOptionDto,)
  }
);}




export const getContainersControllerUpdateContainerOptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerUpdateContainerOption>>, TError,{optionId: string;data: UpdateContainerOptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerUpdateContainerOption>>, TError,{optionId: string;data: UpdateContainerOptionDto}, TContext> => {

const mutationKey = ['containersControllerUpdateContainerOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerUpdateContainerOption>>, {optionId: string;data: UpdateContainerOptionDto}> = (props) => {
          const {optionId,data} = props ?? {};

          return  containersControllerUpdateContainerOption(optionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerUpdateContainerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerUpdateContainerOption>>>
    export type ContainersControllerUpdateContainerOptionMutationBody = UpdateContainerOptionDto
    export type ContainersControllerUpdateContainerOptionMutationError = void

    /**
 * @summary Update a container option
 */
export const useContainersControllerUpdateContainerOption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerUpdateContainerOption>>, TError,{optionId: string;data: UpdateContainerOptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerUpdateContainerOption>>,
        TError,
        {optionId: string;data: UpdateContainerOptionDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerUpdateContainerOptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Hard-deletes an archived option. Rejected (400) if the option is still active, and (409) if work orders still reference it. The caller must belong to the owning partner (or be an Artic admin).
 * @summary Permanently delete an archived container option
 */
export type containersControllerDeleteOptionResponse200 = {
  data: void
  status: 200
}

export type containersControllerDeleteOptionResponse400 = {
  data: void
  status: 400
}

export type containersControllerDeleteOptionResponse401 = {
  data: void
  status: 401
}

export type containersControllerDeleteOptionResponse403 = {
  data: void
  status: 403
}

export type containersControllerDeleteOptionResponse404 = {
  data: void
  status: 404
}

export type containersControllerDeleteOptionResponse409 = {
  data: void
  status: 409
}
    
export type containersControllerDeleteOptionResponseSuccess = (containersControllerDeleteOptionResponse200) & {
  headers: Headers;
};
export type containersControllerDeleteOptionResponseError = (containersControllerDeleteOptionResponse400 | containersControllerDeleteOptionResponse401 | containersControllerDeleteOptionResponse403 | containersControllerDeleteOptionResponse404 | containersControllerDeleteOptionResponse409) & {
  headers: Headers;
};

export type containersControllerDeleteOptionResponse = (containersControllerDeleteOptionResponseSuccess | containersControllerDeleteOptionResponseError)

export const getContainersControllerDeleteOptionUrl = (optionId: string,) => {


  

  return `/containers/options/${optionId}`
}

export const containersControllerDeleteOption = async (optionId: string, options?: RequestInit): Promise<containersControllerDeleteOptionResponse> => {
  
  return customFetch<containersControllerDeleteOptionResponse>(getContainersControllerDeleteOptionUrl(optionId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getContainersControllerDeleteOptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerDeleteOption>>, TError,{optionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerDeleteOption>>, TError,{optionId: string}, TContext> => {

const mutationKey = ['containersControllerDeleteOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerDeleteOption>>, {optionId: string}> = (props) => {
          const {optionId} = props ?? {};

          return  containersControllerDeleteOption(optionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerDeleteOptionMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerDeleteOption>>>
    
    export type ContainersControllerDeleteOptionMutationError = void

    /**
 * @summary Permanently delete an archived container option
 */
export const useContainersControllerDeleteOption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerDeleteOption>>, TError,{optionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerDeleteOption>>,
        TError,
        {optionId: string},
        TContext
      > => {

      const mutationOptions = getContainersControllerDeleteOptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Enable (green) or disable (grey) a single option for a product type — one layer below the container-level link. Admins may scope any option; partner members may scope their own custom options and must reference a product_type option that is global or their own. The option's container must already be linked to the product type. Returns the full container detail so the client can update its cache in one write.
 * @summary Toggle an option <-> product-type scoping (ENG-677)
 */
export type containersControllerToggleContainerOptionProductTypeResponse200 = {
  data: ContainerDetailDto
  status: 200
}

export type containersControllerToggleContainerOptionProductTypeResponse400 = {
  data: void
  status: 400
}

export type containersControllerToggleContainerOptionProductTypeResponse401 = {
  data: void
  status: 401
}

export type containersControllerToggleContainerOptionProductTypeResponse403 = {
  data: void
  status: 403
}

export type containersControllerToggleContainerOptionProductTypeResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerToggleContainerOptionProductTypeResponseSuccess = (containersControllerToggleContainerOptionProductTypeResponse200) & {
  headers: Headers;
};
export type containersControllerToggleContainerOptionProductTypeResponseError = (containersControllerToggleContainerOptionProductTypeResponse400 | containersControllerToggleContainerOptionProductTypeResponse401 | containersControllerToggleContainerOptionProductTypeResponse403 | containersControllerToggleContainerOptionProductTypeResponse404) & {
  headers: Headers;
};

export type containersControllerToggleContainerOptionProductTypeResponse = (containersControllerToggleContainerOptionProductTypeResponseSuccess | containersControllerToggleContainerOptionProductTypeResponseError)

export const getContainersControllerToggleContainerOptionProductTypeUrl = (optionId: string,) => {


  

  return `/containers/options/${optionId}/product-types`
}

export const containersControllerToggleContainerOptionProductType = async (optionId: string,
    toggleOptionProductTypeDto: ToggleOptionProductTypeDto, options?: RequestInit): Promise<containersControllerToggleContainerOptionProductTypeResponse> => {
  
  return customFetch<containersControllerToggleContainerOptionProductTypeResponse>(getContainersControllerToggleContainerOptionProductTypeUrl(optionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      toggleOptionProductTypeDto,)
  }
);}




export const getContainersControllerToggleContainerOptionProductTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerToggleContainerOptionProductType>>, TError,{optionId: string;data: ToggleOptionProductTypeDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerToggleContainerOptionProductType>>, TError,{optionId: string;data: ToggleOptionProductTypeDto}, TContext> => {

const mutationKey = ['containersControllerToggleContainerOptionProductType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerToggleContainerOptionProductType>>, {optionId: string;data: ToggleOptionProductTypeDto}> = (props) => {
          const {optionId,data} = props ?? {};

          return  containersControllerToggleContainerOptionProductType(optionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerToggleContainerOptionProductTypeMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerToggleContainerOptionProductType>>>
    export type ContainersControllerToggleContainerOptionProductTypeMutationBody = ToggleOptionProductTypeDto
    export type ContainersControllerToggleContainerOptionProductTypeMutationError = void

    /**
 * @summary Toggle an option <-> product-type scoping (ENG-677)
 */
export const useContainersControllerToggleContainerOptionProductType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerToggleContainerOptionProductType>>, TError,{optionId: string;data: ToggleOptionProductTypeDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerToggleContainerOptionProductType>>,
        TError,
        {optionId: string;data: ToggleOptionProductTypeDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerToggleContainerOptionProductTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Enable or disable a product_type option for this container. Admins may toggle any container; partner members may toggle their own custom containers (the chosen product_type option must be global or owned by the same partner). The product_type_option_id must belong to the product_type container; the target container cannot be product_type itself. Returns the full container detail so the client can update its cache in one write.
 * @summary Toggle a container <-> product-type link
 */
export type containersControllerToggleContainerProductTypeResponse200 = {
  data: ContainerDetailDto
  status: 200
}

export type containersControllerToggleContainerProductTypeResponse400 = {
  data: void
  status: 400
}

export type containersControllerToggleContainerProductTypeResponse401 = {
  data: void
  status: 401
}

export type containersControllerToggleContainerProductTypeResponse403 = {
  data: void
  status: 403
}

export type containersControllerToggleContainerProductTypeResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerToggleContainerProductTypeResponseSuccess = (containersControllerToggleContainerProductTypeResponse200) & {
  headers: Headers;
};
export type containersControllerToggleContainerProductTypeResponseError = (containersControllerToggleContainerProductTypeResponse400 | containersControllerToggleContainerProductTypeResponse401 | containersControllerToggleContainerProductTypeResponse403 | containersControllerToggleContainerProductTypeResponse404) & {
  headers: Headers;
};

export type containersControllerToggleContainerProductTypeResponse = (containersControllerToggleContainerProductTypeResponseSuccess | containersControllerToggleContainerProductTypeResponseError)

export const getContainersControllerToggleContainerProductTypeUrl = (containerId: string,) => {


  

  return `/containers/${containerId}/product-types`
}

export const containersControllerToggleContainerProductType = async (containerId: string,
    toggleContainerProductTypeDto: ToggleContainerProductTypeDto, options?: RequestInit): Promise<containersControllerToggleContainerProductTypeResponse> => {
  
  return customFetch<containersControllerToggleContainerProductTypeResponse>(getContainersControllerToggleContainerProductTypeUrl(containerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      toggleContainerProductTypeDto,)
  }
);}




export const getContainersControllerToggleContainerProductTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerToggleContainerProductType>>, TError,{containerId: string;data: ToggleContainerProductTypeDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerToggleContainerProductType>>, TError,{containerId: string;data: ToggleContainerProductTypeDto}, TContext> => {

const mutationKey = ['containersControllerToggleContainerProductType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerToggleContainerProductType>>, {containerId: string;data: ToggleContainerProductTypeDto}> = (props) => {
          const {containerId,data} = props ?? {};

          return  containersControllerToggleContainerProductType(containerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerToggleContainerProductTypeMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerToggleContainerProductType>>>
    export type ContainersControllerToggleContainerProductTypeMutationBody = ToggleContainerProductTypeDto
    export type ContainersControllerToggleContainerProductTypeMutationError = void

    /**
 * @summary Toggle a container <-> product-type link
 */
export const useContainersControllerToggleContainerProductType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerToggleContainerProductType>>, TError,{containerId: string;data: ToggleContainerProductTypeDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerToggleContainerProductType>>,
        TError,
        {containerId: string;data: ToggleContainerProductTypeDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerToggleContainerProductTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upserts partner-specific score and weight overrides for a container option. Admin-only.
 * @summary Set partner score/weight overrides for a container option
 */
export type containersControllerSetPartnerOptionOverrideResponse200 = {
  data: PartnerContainerOptionOverrideDto
  status: 200
}

export type containersControllerSetPartnerOptionOverrideResponse401 = {
  data: void
  status: 401
}

export type containersControllerSetPartnerOptionOverrideResponse403 = {
  data: void
  status: 403
}
    
export type containersControllerSetPartnerOptionOverrideResponseSuccess = (containersControllerSetPartnerOptionOverrideResponse200) & {
  headers: Headers;
};
export type containersControllerSetPartnerOptionOverrideResponseError = (containersControllerSetPartnerOptionOverrideResponse401 | containersControllerSetPartnerOptionOverrideResponse403) & {
  headers: Headers;
};

export type containersControllerSetPartnerOptionOverrideResponse = (containersControllerSetPartnerOptionOverrideResponseSuccess | containersControllerSetPartnerOptionOverrideResponseError)

export const getContainersControllerSetPartnerOptionOverrideUrl = () => {


  

  return `/containers/partner/options`
}

export const containersControllerSetPartnerOptionOverride = async (partnerContainerOptionOverrideDto: PartnerContainerOptionOverrideDto, options?: RequestInit): Promise<containersControllerSetPartnerOptionOverrideResponse> => {
  
  return customFetch<containersControllerSetPartnerOptionOverrideResponse>(getContainersControllerSetPartnerOptionOverrideUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partnerContainerOptionOverrideDto,)
  }
);}




export const getContainersControllerSetPartnerOptionOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerSetPartnerOptionOverride>>, TError,{data: PartnerContainerOptionOverrideDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerSetPartnerOptionOverride>>, TError,{data: PartnerContainerOptionOverrideDto}, TContext> => {

const mutationKey = ['containersControllerSetPartnerOptionOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerSetPartnerOptionOverride>>, {data: PartnerContainerOptionOverrideDto}> = (props) => {
          const {data} = props ?? {};

          return  containersControllerSetPartnerOptionOverride(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerSetPartnerOptionOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerSetPartnerOptionOverride>>>
    export type ContainersControllerSetPartnerOptionOverrideMutationBody = PartnerContainerOptionOverrideDto
    export type ContainersControllerSetPartnerOptionOverrideMutationError = void

    /**
 * @summary Set partner score/weight overrides for a container option
 */
export const useContainersControllerSetPartnerOptionOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerSetPartnerOptionOverride>>, TError,{data: PartnerContainerOptionOverrideDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerSetPartnerOptionOverride>>,
        TError,
        {data: PartnerContainerOptionOverrideDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerSetPartnerOptionOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns work-order usage for the option, bucketed by status (Draft / Scheduled / In Progress / Completed), and which confirmation modal to show (standard / blocked / partial). Custom options only; the caller must belong to the owning partner (or be an Artic admin).
 * @summary Pre-check archiving a container option
 */
export type containersControllerPrecheckArchiveOptionResponse200 = {
  data: OptionArchivePrecheckResponseDto
  status: 200
}

export type containersControllerPrecheckArchiveOptionResponse400 = {
  data: void
  status: 400
}

export type containersControllerPrecheckArchiveOptionResponse401 = {
  data: void
  status: 401
}

export type containersControllerPrecheckArchiveOptionResponse403 = {
  data: void
  status: 403
}

export type containersControllerPrecheckArchiveOptionResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerPrecheckArchiveOptionResponseSuccess = (containersControllerPrecheckArchiveOptionResponse200) & {
  headers: Headers;
};
export type containersControllerPrecheckArchiveOptionResponseError = (containersControllerPrecheckArchiveOptionResponse400 | containersControllerPrecheckArchiveOptionResponse401 | containersControllerPrecheckArchiveOptionResponse403 | containersControllerPrecheckArchiveOptionResponse404) & {
  headers: Headers;
};

export type containersControllerPrecheckArchiveOptionResponse = (containersControllerPrecheckArchiveOptionResponseSuccess | containersControllerPrecheckArchiveOptionResponseError)

export const getContainersControllerPrecheckArchiveOptionUrl = (optionId: string,) => {


  

  return `/containers/options/${optionId}/archive-precheck`
}

export const containersControllerPrecheckArchiveOption = async (optionId: string, options?: RequestInit): Promise<containersControllerPrecheckArchiveOptionResponse> => {
  
  return customFetch<containersControllerPrecheckArchiveOptionResponse>(getContainersControllerPrecheckArchiveOptionUrl(optionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContainersControllerPrecheckArchiveOptionQueryKey = (optionId?: string,) => {
    return [
    `/containers/options/${optionId}/archive-precheck`
    ] as const;
    }

    
export const getContainersControllerPrecheckArchiveOptionQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(optionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerPrecheckArchiveOptionQueryKey(optionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>> = ({ signal }) => containersControllerPrecheckArchiveOption(optionId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(optionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerPrecheckArchiveOptionQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>>
export type ContainersControllerPrecheckArchiveOptionQueryError = void


export function useContainersControllerPrecheckArchiveOption<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>,
          TError,
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveOption<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>,
          TError,
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveOption<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Pre-check archiving a container option
 */

export function useContainersControllerPrecheckArchiveOption<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerPrecheckArchiveOptionQueryOptions(optionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Pre-check archiving a container option
 */
export const prefetchContainersControllerPrecheckArchiveOptionQuery = async <TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 queryClient: QueryClient, optionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getContainersControllerPrecheckArchiveOptionQueryOptions(optionId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getContainersControllerPrecheckArchiveOptionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(optionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerPrecheckArchiveOptionQueryKey(optionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>> = ({ signal }) => containersControllerPrecheckArchiveOption(optionId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerPrecheckArchiveOptionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>>
export type ContainersControllerPrecheckArchiveOptionSuspenseQueryError = void


export function useContainersControllerPrecheckArchiveOptionSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveOptionSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveOptionSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Pre-check archiving a container option
 */

export function useContainersControllerPrecheckArchiveOptionSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError = void>(
 optionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveOption>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerPrecheckArchiveOptionSuspenseQueryOptions(optionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Marks the custom option archived (no longer selectable), removes it from the product code on Draft and Scheduled work orders (Scheduled work orders are reopened into redrafting), and leaves In Progress / Completed work orders untouched. Hides the container column if no active option remains and nothing is In Progress, otherwise queues auto-hide. Custom options only; the caller must belong to the owning partner (or be an Artic admin).
 * @summary Archive a container option
 */
export type containersControllerArchiveOptionResponse201 = {
  data: ArchiveOptionResponseDto
  status: 201
}

export type containersControllerArchiveOptionResponse400 = {
  data: void
  status: 400
}

export type containersControllerArchiveOptionResponse401 = {
  data: void
  status: 401
}

export type containersControllerArchiveOptionResponse403 = {
  data: void
  status: 403
}

export type containersControllerArchiveOptionResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerArchiveOptionResponseSuccess = (containersControllerArchiveOptionResponse201) & {
  headers: Headers;
};
export type containersControllerArchiveOptionResponseError = (containersControllerArchiveOptionResponse400 | containersControllerArchiveOptionResponse401 | containersControllerArchiveOptionResponse403 | containersControllerArchiveOptionResponse404) & {
  headers: Headers;
};

export type containersControllerArchiveOptionResponse = (containersControllerArchiveOptionResponseSuccess | containersControllerArchiveOptionResponseError)

export const getContainersControllerArchiveOptionUrl = (optionId: string,) => {


  

  return `/containers/options/${optionId}/archive`
}

export const containersControllerArchiveOption = async (optionId: string,
    archiveOptionRequestDto: ArchiveOptionRequestDto, options?: RequestInit): Promise<containersControllerArchiveOptionResponse> => {
  
  return customFetch<containersControllerArchiveOptionResponse>(getContainersControllerArchiveOptionUrl(optionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      archiveOptionRequestDto,)
  }
);}




export const getContainersControllerArchiveOptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerArchiveOption>>, TError,{optionId: string;data: ArchiveOptionRequestDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerArchiveOption>>, TError,{optionId: string;data: ArchiveOptionRequestDto}, TContext> => {

const mutationKey = ['containersControllerArchiveOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerArchiveOption>>, {optionId: string;data: ArchiveOptionRequestDto}> = (props) => {
          const {optionId,data} = props ?? {};

          return  containersControllerArchiveOption(optionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerArchiveOptionMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerArchiveOption>>>
    export type ContainersControllerArchiveOptionMutationBody = ArchiveOptionRequestDto
    export type ContainersControllerArchiveOptionMutationError = void

    /**
 * @summary Archive a container option
 */
export const useContainersControllerArchiveOption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerArchiveOption>>, TError,{optionId: string;data: ArchiveOptionRequestDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerArchiveOption>>,
        TError,
        {optionId: string;data: ArchiveOptionRequestDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerArchiveOptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Clears archived_at so the option is selectable again. Does not re-add it to work orders it was removed from. 409 if an active option already uses the same code/name. The caller must belong to the owning partner (or be an Artic admin).
 * @summary Restore an archived container option
 */
export type containersControllerRestoreOptionResponse201 = {
  data: void
  status: 201
}

export type containersControllerRestoreOptionResponse401 = {
  data: void
  status: 401
}

export type containersControllerRestoreOptionResponse403 = {
  data: void
  status: 403
}

export type containersControllerRestoreOptionResponse404 = {
  data: void
  status: 404
}

export type containersControllerRestoreOptionResponse409 = {
  data: void
  status: 409
}
    
export type containersControllerRestoreOptionResponseSuccess = (containersControllerRestoreOptionResponse201) & {
  headers: Headers;
};
export type containersControllerRestoreOptionResponseError = (containersControllerRestoreOptionResponse401 | containersControllerRestoreOptionResponse403 | containersControllerRestoreOptionResponse404 | containersControllerRestoreOptionResponse409) & {
  headers: Headers;
};

export type containersControllerRestoreOptionResponse = (containersControllerRestoreOptionResponseSuccess | containersControllerRestoreOptionResponseError)

export const getContainersControllerRestoreOptionUrl = (optionId: string,) => {


  

  return `/containers/options/${optionId}/restore`
}

export const containersControllerRestoreOption = async (optionId: string, options?: RequestInit): Promise<containersControllerRestoreOptionResponse> => {
  
  return customFetch<containersControllerRestoreOptionResponse>(getContainersControllerRestoreOptionUrl(optionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getContainersControllerRestoreOptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerRestoreOption>>, TError,{optionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerRestoreOption>>, TError,{optionId: string}, TContext> => {

const mutationKey = ['containersControllerRestoreOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerRestoreOption>>, {optionId: string}> = (props) => {
          const {optionId} = props ?? {};

          return  containersControllerRestoreOption(optionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerRestoreOptionMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerRestoreOption>>>
    
    export type ContainersControllerRestoreOptionMutationError = void

    /**
 * @summary Restore an archived container option
 */
export const useContainersControllerRestoreOption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerRestoreOption>>, TError,{optionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerRestoreOption>>,
        TError,
        {optionId: string},
        TContext
      > => {

      const mutationOptions = getContainersControllerRestoreOptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns aggregate work-order usage plus a per-option pre-check list (each with its modal), driving the guided per-option archive wizard. Custom containers only; the caller must belong to the owning partner (or be an Artic admin).
 * @summary Pre-check archiving a full container
 */
export type containersControllerPrecheckArchiveContainerResponse200 = {
  data: ContainerArchivePrecheckResponseDto
  status: 200
}

export type containersControllerPrecheckArchiveContainerResponse400 = {
  data: void
  status: 400
}

export type containersControllerPrecheckArchiveContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerPrecheckArchiveContainerResponse403 = {
  data: void
  status: 403
}

export type containersControllerPrecheckArchiveContainerResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerPrecheckArchiveContainerResponseSuccess = (containersControllerPrecheckArchiveContainerResponse200) & {
  headers: Headers;
};
export type containersControllerPrecheckArchiveContainerResponseError = (containersControllerPrecheckArchiveContainerResponse400 | containersControllerPrecheckArchiveContainerResponse401 | containersControllerPrecheckArchiveContainerResponse403 | containersControllerPrecheckArchiveContainerResponse404) & {
  headers: Headers;
};

export type containersControllerPrecheckArchiveContainerResponse = (containersControllerPrecheckArchiveContainerResponseSuccess | containersControllerPrecheckArchiveContainerResponseError)

export const getContainersControllerPrecheckArchiveContainerUrl = (containerId: string,) => {


  

  return `/containers/${containerId}/archive-precheck`
}

export const containersControllerPrecheckArchiveContainer = async (containerId: string, options?: RequestInit): Promise<containersControllerPrecheckArchiveContainerResponse> => {
  
  return customFetch<containersControllerPrecheckArchiveContainerResponse>(getContainersControllerPrecheckArchiveContainerUrl(containerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContainersControllerPrecheckArchiveContainerQueryKey = (containerId?: string,) => {
    return [
    `/containers/${containerId}/archive-precheck`
    ] as const;
    }

    
export const getContainersControllerPrecheckArchiveContainerQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(containerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerPrecheckArchiveContainerQueryKey(containerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>> = ({ signal }) => containersControllerPrecheckArchiveContainer(containerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(containerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerPrecheckArchiveContainerQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>>
export type ContainersControllerPrecheckArchiveContainerQueryError = void


export function useContainersControllerPrecheckArchiveContainer<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>,
          TError,
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveContainer<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>,
          TError,
          Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveContainer<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Pre-check archiving a full container
 */

export function useContainersControllerPrecheckArchiveContainer<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerPrecheckArchiveContainerQueryOptions(containerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Pre-check archiving a full container
 */
export const prefetchContainersControllerPrecheckArchiveContainerQuery = async <TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 queryClient: QueryClient, containerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getContainersControllerPrecheckArchiveContainerQueryOptions(containerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getContainersControllerPrecheckArchiveContainerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(containerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContainersControllerPrecheckArchiveContainerQueryKey(containerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>> = ({ signal }) => containersControllerPrecheckArchiveContainer(containerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContainersControllerPrecheckArchiveContainerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>>
export type ContainersControllerPrecheckArchiveContainerSuspenseQueryError = void


export function useContainersControllerPrecheckArchiveContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContainersControllerPrecheckArchiveContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Pre-check archiving a full container
 */

export function useContainersControllerPrecheckArchiveContainerSuspense<TData = Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError = void>(
 containerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof containersControllerPrecheckArchiveContainer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContainersControllerPrecheckArchiveContainerSuspenseQueryOptions(containerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Applies the per-option archive rules to every option in one transaction (the guided wizard sends the confirmed decisions). Any "skip" leaves that option active and the container itself un-archived (no partial container archive state). Returns the completion summary. Custom containers only; the caller must belong to the owning partner (or be an Artic admin).
 * @summary Archive a full container
 */
export type containersControllerArchiveContainerResponse201 = {
  data: ArchiveCompletionSummaryResponseDto
  status: 201
}

export type containersControllerArchiveContainerResponse400 = {
  data: void
  status: 400
}

export type containersControllerArchiveContainerResponse401 = {
  data: void
  status: 401
}

export type containersControllerArchiveContainerResponse403 = {
  data: void
  status: 403
}

export type containersControllerArchiveContainerResponse404 = {
  data: void
  status: 404
}
    
export type containersControllerArchiveContainerResponseSuccess = (containersControllerArchiveContainerResponse201) & {
  headers: Headers;
};
export type containersControllerArchiveContainerResponseError = (containersControllerArchiveContainerResponse400 | containersControllerArchiveContainerResponse401 | containersControllerArchiveContainerResponse403 | containersControllerArchiveContainerResponse404) & {
  headers: Headers;
};

export type containersControllerArchiveContainerResponse = (containersControllerArchiveContainerResponseSuccess | containersControllerArchiveContainerResponseError)

export const getContainersControllerArchiveContainerUrl = (containerId: string,) => {


  

  return `/containers/${containerId}/archive`
}

export const containersControllerArchiveContainer = async (containerId: string,
    archiveContainerRequestDto: ArchiveContainerRequestDto, options?: RequestInit): Promise<containersControllerArchiveContainerResponse> => {
  
  return customFetch<containersControllerArchiveContainerResponse>(getContainersControllerArchiveContainerUrl(containerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      archiveContainerRequestDto,)
  }
);}




export const getContainersControllerArchiveContainerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerArchiveContainer>>, TError,{containerId: string;data: ArchiveContainerRequestDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof containersControllerArchiveContainer>>, TError,{containerId: string;data: ArchiveContainerRequestDto}, TContext> => {

const mutationKey = ['containersControllerArchiveContainer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof containersControllerArchiveContainer>>, {containerId: string;data: ArchiveContainerRequestDto}> = (props) => {
          const {containerId,data} = props ?? {};

          return  containersControllerArchiveContainer(containerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContainersControllerArchiveContainerMutationResult = NonNullable<Awaited<ReturnType<typeof containersControllerArchiveContainer>>>
    export type ContainersControllerArchiveContainerMutationBody = ArchiveContainerRequestDto
    export type ContainersControllerArchiveContainerMutationError = void

    /**
 * @summary Archive a full container
 */
export const useContainersControllerArchiveContainer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof containersControllerArchiveContainer>>, TError,{containerId: string;data: ArchiveContainerRequestDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof containersControllerArchiveContainer>>,
        TError,
        {containerId: string;data: ArchiveContainerRequestDto},
        TContext
      > => {

      const mutationOptions = getContainersControllerArchiveContainerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    